import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../../dropdown'

import { AuthImatgeMaterial } from './AuthImatgeMaterial'
import { AuthSortides, AuthSortidesMenors } from './AuthSortides'
import { AuthGDPR } from '../common/AuthGDPR'

export function EnrolmentFormAuthorizations(props) {

  const [errors, setErrors] = useState({});

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  /* AUTORITZACIONS */
  const [authorizationsOpen, setAuthorizationsOpen] = useState(true);

  const toggleAuthorizationsOpen = () => {
    setAuthorizationsOpen(!authorizationsOpen);
  }

  const [authIntranet, setAuthIntranet ] = useState(false);
  const [authPublicacions, setAuthPublicacions ] = useState(false);
  const [authMaterial, setAuthMaterial ] = useState(false);
  const [authInternet, setAuthInternet ] = useState(false);
  const [authGDPR, setAuthGDPR] = useState("0");
  const [authSortides, setAuthSortides ] = useState("0");

  const [dadesAutoritzacions, setDadesAutoritzacions] = useState({validat: false});

  const handleDadesAutoritzacions = (noError) => {

    let d = {
     "validat": noError,

    /* DADES AUTORITZACIONS */
    "authIntranet": authIntranet,
    "authPublicacions": authPublicacions,
    "authMaterial": authMaterial,
    "authInternet": authInternet,
    "authGDPR": authGDPR,
    "authSortides": authSortides
    }

      console.log("DADES_AUTORITZACIONS",d)
      setDadesAutoritzacions(d)
      props.handleDadesAutoritzacions(d)
    }

  const validaAuthIntranet = () => {
    return authIntranet ? null : "Heu d'indicar una resposta"
  }

  const validaAuthPublicacions= () => {
    return authPublicacions ? null : "Heu d'indicar una resposta"
  }

  const validaAuthMaterial= () => {
    return authMaterial ? null : "Heu d'indicar una resposta"
  }

  const validaAuthInternet= () => {
    return authInternet ? null : "Heu d'indicar una resposta"
  }

  const validaAuthGDPR= () => {
    return authGDPR === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthSortides= () => {
    return authSortides === "1" ? null : "Aquest camp és obligatori"
  }

 const handleChangeIntranet = (t) => { setAuthIntranet(t) }
 const handleChangePublicacions = (t) => { setAuthPublicacions(t) }
 const handleChangeMaterial = (t) => { setAuthMaterial(t) }
 const handleChangeInternet = (t) => { setAuthInternet(t) }

 const handleChangeSortides = (t) => {

      setAuthSortides(t === "0" ? "1" : "0")

      handleDadesAutoritzacions(false)
}


 const handleChangeGDPR = (t) => {

      setAuthGDPR(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }



/* VALIDA AUTORITZACIONS */
const validaAutoritzacions = (e) => {
  if(e) e.preventDefault();

  let error = {}

  error.authIntranet = validaAuthIntranet();
  handleErrors('authIntranet',error)

  error.authPublicacions = validaAuthPublicacions();
  handleErrors('authPublicacions',error)

  error.authMaterial = validaAuthMaterial();
  handleErrors('authMaterial',error)

  error.authInternet = validaAuthInternet();
  handleErrors('authInternet',error)

  error.authGDPR = validaAuthGDPR();
  handleErrors('authGDPR',error)

  error.authSortides = validaAuthSortides();
  handleErrors('authSortides',error)

  setErrors(error)

  let noError = true;
  //DEVELOP
  Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )

  console.log('ERROR',error);

  handleDadesAutoritzacions(noError)

  if(noError)
  {
     setAuthorizationsOpen(false);
  }

  return noError;
}


  return (
    <div className="container authorizations">
      <div className="row">
        <div className="col col-12 ">
          <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
            <div className="t-Region-header">
              <div className="t-Region-headerItems  t-Region-headerItems--controls">
                <button
                  className="t-Button t-Button--icon t-Button--hideShow"
                  type="button"
                  onClick={toggleAuthorizationsOpen}
                >
                  {authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronUp}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                  {!authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                </button>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--title">
                <h2 className="t-Region-title a-Collapsible-heading">
                  Protecció de dades
                </h2>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
            </div>
            <div className="t-Region-bodyWrap">
              <Dropdown open={authorizationsOpen}>
                <div className="t-Region-body a-Collapsible-content">
                  <div className="container">
                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">

                                <AuthImatgeMaterial
                                  enguany={props.enguany} anyVinent={props.anyVinent}
                                  authIntranet={authIntranet} handleChangeIntranet={handleChangeIntranet} errorIntranet={errors.authIntranet}
                                  authPublicacions={authPublicacions} handleChangePublicacions={handleChangePublicacions} errorPublicacions={errors.authPublicacions}
                                  authInternet={authInternet} handleChangeInternet={handleChangeInternet} errorInternet={errors.authInternet}
                                  authMaterial={authMaterial} handleChangeMaterial={handleChangeMaterial} errorMaterial={errors.authMaterial}
                                />

                                <br/>

                                { props.dadesPersonals.edat < 18 ? (
                                  <AuthSortidesMenors auth={authSortides} handleChange={handleChangeSortides} error={errors.authSortides} />
                                ) : (
                                  <AuthSortides auth={authSortides} handleChange={handleChangeSortides} error={errors.authSortides} />
                                )
                                }

                                <br/>

                                <AuthGDPR auth={authGDPR} handleChange={handleChangeGDPR} error={errors.authGDPR} />

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                  <div className="container">
                            <div className="row">
                              <div className="col col-12" align="center">
                                <button onClick={validaAutoritzacions} className="button">SEGÜENT</button>
                              </div>
                            </div>
                          </div>




                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
